// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1e258fd3","952":"2c5061b5"}[chunkId] + ".chunk.js";
};